export default "<div *ngFor=\"let item of list\">\r\n    {{item.id}}\r\n    <div [id]=\"item.id\">.</div>\r\n</div>x`";